import React from "react";
import Box from "@redbubble/design-system/react/Box";

import styles from "./ImageProtection.scss";

const ImageProtection = () => {
  return <div className={styles.gif} />;
};

// eslint-disable-next-line react/prop-types
export const ImageProtectContainer = ({ children }) => {
  return (
    <Box style={{ position: "relative" }}>
      {children}
      <ImageProtection />
    </Box>
  );
};

export default ImageProtection;
